import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

function useShowComparison(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.COMPARISON_FE, false);
}

export { useShowComparison };
